function is_home() { return window.location.pathname === '/'; }

$(function ($) {

  $( 'html' ).removeClass( 'no-js' ).addClass( 'js' );

  if( is_home() ) {
    $( 'a[href$="/accueil#contact"]' ).attr( 'href', '#contact' ).addClass( 'smooth' );
  }

  $( '.smooth' ).on( 'click', function() {
		$( 'html, body' ).animate( {
      scrollTop: $( $(this).attr( 'href' ) ).offset().top
    }, 750 );
	});

});
